import { render, staticRenderFns } from "./WorkButton.vue?vue&type=template&id=603d799a"
import script from "./WorkButton.vue?vue&type=script&lang=js"
export * from "./WorkButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports